module.exports = __webpack_public_path__ + "static/media/settings.b0f30ba4.svg";